import { Box, Button } from "@mui/material"
import Images from "../../assets/js/Images"
import SkeletonImage from "./SkeletonImage"
import Icons from "../../assets/js/Icons"

function NotFound() {
  return (
    <Box
      sx={{
        display: "grid",
        minHeight: "100vh",
        placeContent: "center",
      }}
    >
      <SkeletonImage
        src={Images?.notFound}
      />
      <Button
        sx={{
          mt: 4,
          minWidth: "150px",
          bgcolor: "#614ba9",
          justifySelf: "center",
          justifyContent: "center",
          ":hover": { bgcolor: "#503d8a" }
        }}
        variant="contained"
        startIcon={<Icons.Backward1 />}
        onClick={() => { window?.history?.back() }}
      >Back</Button>
    </Box>
  )
}

export default NotFound